export default __webpack_public_path__ + "static/media/builtLicitatii.40f27caa.png";